export const INFRASTRUCTURE_MF_NAME = 'map-search-frontend';

export const NEWBUILDING_MORTGAGE_CALCULATOR_MF_NAME = 'newbuilding-mortgage-calculator-frontend';
export const MORTGAGE_CALCULATOR_MF_NAME = 'mortgage-calculator-micro-frontend';
